import { render } from "./TagNfcPage.vue?vue&type=template&id=79f403a9&scoped=true&ts=true"
import script from "./TagNfcPage.vue?vue&type=script&lang=ts"
export * from "./TagNfcPage.vue?vue&type=script&lang=ts"

import "./TagNfcPage.vue?vue&type=style&index=0&id=79f403a9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f403a9"]])

export default __exports__